import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const AtIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11c1.358 0 2.662-.247 3.865-.698a.825.825 0 1 0-.58-1.545A9.323 9.323 0 0 1 12 21.35 9.338 9.338 0 0 1 2.65 12 9.338 9.338 0 0 1 12 2.65 9.338 9.338 0 0 1 21.35 12v1.375a2.462 2.462 0 0 1-2.475 2.475 2.462 2.462 0 0 1-2.475-2.475v-6.05a.825.825 0 1 0-1.65 0v.587c-.87-.87-2.018-1.412-3.3-1.412C8.668 6.5 6.5 9.027 6.5 12s2.168 5.5 4.95 5.5c1.58 0 2.96-.816 3.86-2.065a4.132 4.132 0 0 0 3.565 2.065A4.137 4.137 0 0 0 23 13.375V12c0-6.065-4.935-11-11-11zm-.55 7.15c1.768 0 3.3 1.667 3.3 3.85s-1.532 3.85-3.3 3.85c-1.768 0-3.3-1.667-3.3-3.85s1.532-3.85 3.3-3.85z"
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

export default AtIcon;
